<template lang="html">
  <div id="travel-page">

    <section class="header-banners-section-s2">
    </section>

    <section class="container main-section">
      <div class="row">
        <div class="col-lg-7 mt-3 mt-lg-0 col-content">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><router-link to="/">Inicio</router-link></li>
            <li class="breadcrumb-item"><router-link to="/quiero-viajar">Quiero Viajar</router-link></li>
            <li class="breadcrumb-item active" aria-current="page">{{row.name}}</li>
          </ol>

          <div class="mb-2">
            <h1 class="title-s1">{{row.name}}</h1>
          </div>

          <div class="box-content">{{row.description}}
          </div>

          <p class="mt-4 text-center">
            <router-link class="btn btn-s2 bg-c-primary" to="/agentes">Contactar a un Agente</router-link>
          </p>
        </div>

        <div class="col-lg-5 col-image">
          <div class="image">
            <img :src="row.imageUrl">
          </div>
        </div>
      </div>
    </section>

  </div>
</template>


<script>
export default {
  data() {
    return {
      row:[],
    }
  },
  methods:{
    getInfo(){
      axios.get(tools.url('/api/travelsDetail/'+this.$route.params.id)).then((response)=>{
        this.row = response.data;
      
      }).catch((error)=>{
      
      })
    },
  },
  mounted() {
      this.getInfo();
  },
}
</script>

